import React,{ useEffect, useState,useContext} from 'react';
import Layout from "../components/Layout";

import { getRoles,getUsers,findUsersService,deleteUser } from "../Services/UserServices";

import AuthContext from '../Context/AuthContext';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import classes from "../components/Users.module.scss";

import UsersFinder from "../components/UsersFinder";
import {StringToBinary, StringFromBinary} from "../utils/Base64Utils"
// coments

import icon_delete from '../assets/images/delete-icon.png';
import icon_profile from '../assets/images/profile.png';
import icon_backward from '../assets/images/backward.png';
import icon_forward from '../assets/images/forward.png';


const TIMEOT_SESSION_CLOSES = 3000;
const USERS_REGS = 10;

function Users (){

  

  const [ currentPage, setCuerrentPage ] = useState( 0 );
  const [ usersPages, setUsersPages ]    = useState( USERS_REGS );
  const [ users, setUsers ] = useState([]);
  const [ enable_finder, set_enable_finder ] = useState(false);
  const [ data_finder, set_data_finder ] = useState('');
  const [ available_roles,set_available_roles ] = useState([]);
  
  const [ data_response, set_data_response ] = useState(null);

  const context = useContext(AuthContext);
  const navigate = useNavigate();
  
  async function updateRoles(){
    getRoles().then(
      async res => {
        if(res.status === 'OK' )
        {
          console.log( res )
          set_available_roles( res.msg );
        }
        else service_error_handler();
      }
    );
  }

  function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }

                                                                  // handles error from API
  async function service_error_handler()
  {
          Swal.fire({
            title: 'Se produjo un error',
            text: 'Se cerrará la sesión actual en ' + TIMEOT_SESSION_CLOSES/1000 + ' segundos',
            icon: 'error',
            timer: TIMEOT_SESSION_CLOSES,
            showCancelButton: false,
            showConfirmButton: false                
          });
          await timeout( TIMEOT_SESSION_CLOSES );
          context.logoutUser();
          navigate('/');
  }

  useEffect(() => {
        console.log( data_response )
        if ( data_response ) {
          if( data_response.caller === 'updateUsersList'  )
          {
            if( !enable_finder )
            {
              setUsers( ...data_response.data.users );
              setUsersPages( data_response.data.pages );
              setCuerrentPage( data_response.data.current_page );
            }
          }
          if( data_response.caller === 'findUsersService'  )
          {
            if( enable_finder )
            {
              setUsers( ...data_response.data.users );
              setUsersPages( data_response.data.pages );
              setCuerrentPage( data_response.data.current_page );
            }
          }          
        }
      }, [ data_response ]);
                                                                  // updates user list, all them..
  function updateUsersList( _currentPage )
  {
    console.log( _currentPage );            
    const ob = {
      from:_currentPage,
      regs:USERS_REGS
    };
    getUsers( ob ).then(
      async res => {
        //console.log( res );            
        console.log( 'Ena: ' + enable_finder )
        if(res.status === 'OK' )
        {
          set_data_response(
            {
              caller:'updateUsersList',
              data:res.msg
            }
          );
        }
        else service_error_handler();
      }
    );
  }
  

  

  async function findUsers( data ){
        console.log( data );            
    
    findUsersService( {data:data.data,from:data.currentPage,regs:USERS_REGS} ).then(
      async res => {
        console.log( res );            
        if(res.status === 'OK')
        {
          console.log( res.msg.users )
          set_data_response(
            {
              caller:'findUsersService',
              data:res.msg
            }
          );
        }
        else service_error_handler();
      }
    );
  }


                                                  // reset navigation registers  
  function rst_page_references()
  {
      setUsers( [] );
      setUsersPages( USERS_REGS );
      setCuerrentPage( 0 );
  }



                                                  // button functionabilities
                                                  // backward
  const btnHandlerPrevPage = async() => {
    let _page = 0;
    if( currentPage > 0 )_page = currentPage-1;
    setCuerrentPage( _page );
    if( !enable_finder )updateUsersList( _page );
    else findUsers( {data:data_finder,currentPage:_page} );
  }
                                                  // forward
  const btnHandlerNextPage = async() => {
    let _page = currentPage;
    if( currentPage < (usersPages-1) )_page = currentPage+1;
    setCuerrentPage( _page );
    if( !enable_finder )updateUsersList( _page );
    else findUsers( {data:data_finder,currentPage:_page} );
  }
                                                // handler for finder component: sets data to search
                                                // from finder inpute text box
  function updateUsersListFromFinder( data )
  {
    if( enable_finder )
    {
      set_data_finder( data.data );
      findUsers( {data:data.data,currentPage:currentPage} );
    }
  }

  function load_default()
  {
      updateUsersList( 0 );
      updateRoles();
  }

  useEffect(
    () => {
      load_default();
    },[]
  );

  const handleView = event =>{
    var user = null;
    users.forEach( _usr =>{
      if( _usr.id_usuario === event.target.id )user = _usr;
    });
    if( user ){
      user.available_roles = available_roles;
      user.logged_user = false;
      user.logged_user_id = context.userInfo.id;
      if( context.userInfo.user ===  user.usuario )user.logged_user = true;
      //console.log( user )
      const user_str = JSON.stringify( user );
      navigate( '/viewuser/'+ StringToBinary( user_str ));
      
    }

  }


 const handleDelete = event =>{
  console.log( event.target.id );
  var _delete_username = null;
  users.forEach( u => {if(u.id_usuario === event.target.id ) _delete_username = u.usuario;})
                                                  // can't delete admin, and can't delete himself
  if( 
        context.userInfo.id !==  event.target.id 
    &&  event.target.id !== '1' )

  Swal.fire({
    title: 'Confirmar eliminación',
    text: 'Desea eliminar el usuario ID: ' + event.target.id + '?',
    icon: 'warning',
    confirmButtonText: 'Sí, eliminarlo!',
    cancelButtonText: "No, cancelar",
    showCancelButton: true,
  }).then(
    function(isConfirm) 
    {
      //console.log(isConfirm.isConfirmed)

      if(isConfirm.isConfirmed){
        
        deleteUser( _delete_username ).then(
          async res => {
            if(res.status === 'OK')
            {
              Swal.fire({
                title: 'Usuario eliminado',
                text: "El usuario se elimino correctamente",
                icon: 'success',
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false
              });
              await timeout(2000);
              load_default();
            }
            else{
              Swal.fire({
                title: 'Se produjo un error',
                text: 'Se produjo un error al eliminar el usuario: ' + res.msg,
                icon: 'error',
                confirmButtonText: 'Cerrar',
                showConfirmButton: true,
              });
              await timeout( TIMEOT_SESSION_CLOSES );
            }
          }
        );
      }
    }
  );

} 

                                                    // change state event triger: is called from finder
useEffect(() => {
        // This will run after 'enable_finder' is updated
        console.log( enable_finder )
        if( !enable_finder )updateUsersList( 0 );
        // Perform actions based on the new count
  }, [enable_finder]); 

function userFinderEna( ena )
{
    console.log( ena )
    rst_page_references();
    set_enable_finder( ena );
}

  return(
    <Layout>
      <UsersFinder updateUser={ updateUsersListFromFinder } userFinderEna ={ userFinderEna }/>
      
      <div className={classes.UsersHeadList}>
        <div className={classes.UsersHeadItems_1}></div>
        <div className={classes.UsersHeadItems_2}>Usuarios por página: {USERS_REGS} </div>
        <div className={classes.UsersHeadItems_3}>Página: {currentPage+1}</div>
        <div className={classes.UsersHeadItems_4}>

            <div  className={classes.navUsersBtn}>
              <div className='row d-flex'>
                <div className="col-sm">
                  <img onClick={btnHandlerPrevPage} className={classes.logo_nav} src={icon_backward}/>
                </div>
                <div className="col-sm">
                  <img onClick={btnHandlerNextPage} className={classes.logo_nav} src={icon_forward} />
                </div>
              </div>
            </div>

        </div>
      </div>

      <div className={classes.UsersHeadList}>
        <div className={classes.UsersHeadItems_1}>Id</div>
        <div className={classes.UsersHeadItems_2}>Usuario</div>
        <div className={classes.UsersHeadItems_3}>Rol</div>
        <div className={classes.UsersHeadItems_4}>Opción</div>
      </div>


       <div className={classes.UserBodyList}>
       
        {
            users.map(
              user=>
              <div key={user.id_usuario} 
                className={ 
                   context.userInfo.user ===  user.usuario ? classes.UserLoggedResultLine : classes.UserResultLine
                  } >
                <div className={classes.UsersHeadItems_1}>{user.id_usuario}</div>
                <div className={classes.UsersHeadItems_2}>{user.usuario}</div>
                  <div className={classes.UsersHeadItems_3}>{user.rol}</div>
                  <div className={classes.UsersOptions}>
                      <div>
                        <div title="Ver usuario">
                          <img onClick={handleView} id={user.id_usuario} className={classes.logo} src={icon_profile}/>
                        </div>
                      </div>

                      <div>
                        <div title="Eliminar Usuario">
                          <img onClick={handleDelete} id={user.id_usuario} className={classes.logo} src={icon_delete}/>
                        </div>
                      </div>
                  </div>
              </div>
            )
          
        }
       
       </div>

    </Layout>
  )
}

export default Users